import { createSelector } from 'reselect';

export const selectStateWidget = () => state => state.widget;

export const selectStateWidgetList = () =>
  createSelector(selectStateWidget(), widget => widget.widgetList);
